import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "../../i18n/LanguageContext";

const STORAGE_KEY = "elite_cookie_notice_dismissed";

export const CookieBanner = () => {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setVisible(true);
  }, []);

  const dismiss = () => {
    localStorage.setItem(STORAGE_KEY, "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      className="fixed bottom-0 left-0 right-0 z-[60] bg-[#111111] border-t border-white/10 px-4 sm:px-6 py-4"
    >
      <div className="max-w-7xl mx-auto flex flex-col sm:flex-row items-center gap-4 justify-between">
        <p className="text-sm text-white/70 leading-relaxed">{t("cookieBanner.text")}</p>
        <div className="flex items-center gap-3 shrink-0">
          <Link to="/cookiebeleid" data-testid="cookie-banner-more-info" className="text-sm text-gold hover:underline">
            {t("cookieBanner.moreInfo")}
          </Link>
          <button
            data-testid="cookie-banner-accept"
            onClick={dismiss}
            className="bg-gold text-white text-sm px-5 py-2 hover:bg-gold-hover transition-colors"
          >
            {t("cookieBanner.accept")}
          </button>
        </div>
      </div>
    </div>
  );
};
